module.exports = __webpack_public_path__ + "static/media/inf_49og61.e578ce9a.mp3";